export default function WhyDifferentApproach() {
  const cards = [
    {
      icon: 'ri-search-eye-line',
      title: 'Глубокая диагностика',
      desc: 'Каждая программа начинается с изучения бизнеса: интервью с руководителями, анализ переговоров, аудит KPI и воронки продаж. Без диагностики невозможно построить эффективное обучение.'
    },
    {
      icon: 'ri-tools-fill',
      title: 'Практика вместо лекций',
      desc: 'Минимум теории, максимум реальных кейсов. 80% времени тренинга — это практические упражнения, ролевые игры, разбор звонков и переписок. Участники не слушают, а действуют.'
    },
    {
      icon: 'ri-file-list-3-line',
      title: 'Работа с реальными ситуациями',
      desc: 'На тренинге разбираются не абстрактные примеры из учебников, а реальные переговоры, звонки и переписки компании. Каждый кейс взят из практики конкретного бизнеса.'
    },
    {
      icon: 'ri-rocket-line',
      title: 'Внедрение изменений',
      desc: 'Обучение не заканчивается в последний день тренинга. Разрабатывается план внедрения, создаются регламенты, скрипты и чек-листы, которые остаются в компании.'
    },
    {
      icon: 'ri-chat-smile-3-line',
      title: 'Сопровождение после обучения',
      desc: 'Разбор кейсов, домашние задания с обратной связью, Telegram-чат для оперативных вопросов, регулярные встречи с руководителем. Сопровождение длится от 1 до 6 месяцев.'
    },
    {
      icon: 'ri-bar-chart-grouped-line',
      title: 'Измеримый результат',
      desc: 'Главная цель — изменение KPI бизнеса: рост конверсии, увеличение среднего чека, сокращение цикла сделки, снижение текучести. Фиксируем показатели до и после.'
    }
  ];

  return (
    <section id="approach" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Почему компании выбирают именно такой подход
          </h2>

        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cards.map((card, i) => (
            <div key={i} className="bg-gray-50 rounded-xl p-6 md:p-7 hover:shadow-md hover:-translate-y-0.5 transition-all duration-300 group cursor-default">
              <div className="w-12 h-12 bg-teal-100 rounded-xl flex items-center justify-center mb-5 group-hover:bg-teal-600 transition-colors duration-300 flex-shrink-0">
                <i className={`${card.icon} text-xl text-teal-600 group-hover:text-white transition-colors duration-300`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-3">{card.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{card.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}